export const HomepageBanner = (() => {
	'use strict';

	function init() {
		
		var $borderParent = $('.banner__background');

		
			$borderParent.addClass('animated');
		
	}

	return {
		init: init,
		name: 'homepage-banner'
	};
})();
